import { render, staticRenderFns } from "./InvoiceDetailModal.vue?vue&type=template&id=4d908534&scoped=true"
import script from "./InvoiceDetailModal.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailModal.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetailModal.vue?vue&type=style&index=0&id=4d908534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d908534",
  null
  
)

export default component.exports